import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Link, Redirect} from 'react-router-dom';
import Overlay from '../../Miscelania/Overlay';

class TrainingRevisionsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      training_id: '',
      training_status: '',
      training_revisions: [],
    };

    this.redirectRevision = this.redirectRevision.bind(this);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.training_revisions)){
      this.setState({
        training_revisions: newProps.training_revisions,
      });
    }
    if(typeof newProps.training_id !== 'undefined'){
      this.setState({
        training_id: newProps.training_id,
        training_status: newProps.training_status,
      });
    }
  }

  createRevision(value, event) {
    event.preventDefault();
    var self = this;
    if (window.confirm('Tem certeza que deseja criar uma revisão de trienamento?')) {
      self.props.handleAlert('', '', 'open');
      var datasave = {
        id: value,
      };
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/criar/revisao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = config.get('url') + '/treinamento/' + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status,
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            document.location = url;
          }
            self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  redirectRevision (url) {
    window.location.href = url;
  }
  
  render() {
    var self = this;
    var training_id_int = parseInt(self.state.training_id);
    var training_status = parseInt(self.state.training_status);
    var verify_revision_opened = 0;
    Object.keys(self.state.training_revisions).map(function(k) {
      if (self.state.training_revisions[k].status === 1) {
        verify_revision_opened = 1;
      }
    })
      return (
<div>
  <RequestApi ref={'request_api'} />
  <Overlay overlay={this.state.overlay} handleAlert={this.props.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <h3 className="page-title">Revisões</h3>
  <hr/>
  {(verify_revision_opened === 0 && training_status !== 4) ? 
      <div>
        <button onClick={this.createRevision.bind(this, training_id_int)} className='btn btn-lg btn-block btn-primary' alt='Criar revisão' title='Criar revisão'><i className="fa fa-fw fa-pencil"></i> Criar revisão</button>     
        <hr/>
      </div>  
    : ""
  }
  <hr/>
  {(self.state.training_revisions === null || typeof self.state.training_revisions === 'undefined') ?  <div><small><em>Nenhuma revisão para este treinamento.</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="col-md-9 text-center">Data de criação</th>
          <th className="col-md-3 text-center">Status</th>
          <th className="col-md-3 text-center">Ações</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.training_revisions).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.training_revisions[k].created_at}</td>
              <td className="text-center">{self.state.training_revisions[k].status_str}</td>
              <td className="text-center">
                {(self.state.training_revisions[k].id === training_id_int) ?  
                  ""
                  : 
                  <button className={'btn btn-info btn-sm'} onClick={() => { self.redirectRevision('/treinamento/' + self.state.training_revisions[k].id); }}>
                    <i className="fa fa-fw fa-eye"></i>
                  </button>
                }         
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
</div>
    );
  }
}

export default TrainingRevisionsTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingRevisionsTab.js